import React, { Suspense } from 'react';
import { observer } from 'mobx-react';
import { useWithdrawService } from '../../hooks/useWithdrawService';
import { ResultModalType } from '../../services/WithdrawService';
import { PayeerSuccessModal } from './Payeer';
import { CommonSuccessModal } from './Common';
import { CardSuccessModal } from './Card';
import { UTTSuccessModal } from './UTT';
import { BankSuccessModal } from './Bank';
import { AlfaSuccessModal } from './Alfa';
import { Loader } from '../Loader';

const typeToComponent: Record<ResultModalType, React.FC> = {
  ALFA_BANK: AlfaSuccessModal,
  BANK: BankSuccessModal,
  CARD: CardSuccessModal,
  PAYEER: PayeerSuccessModal,
  UTT: UTTSuccessModal,
};

export const SuccessModal: React.FC = observer(() => {
  const { resultModalType } = useWithdrawService();

  const Component = (resultModalType && typeToComponent[resultModalType]) || CommonSuccessModal;

  return (
    <Suspense fallback={<Loader />}>
      <Component />
    </Suspense>
  );
});
